import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { normalizeStringForSort } from '../../misc/normalizeStringForSort';
import { useSelector } from 'react-redux';
import { useEvent } from '../eventHooks';

export function useEventSpeakers(eventId, { filter, sortBy: sortFunction } = {}) {
    const selector = useCallback((state) => state.events[eventId]?.speakers.listed, [eventId]),
        speakers = useSelector(selector),
        event = useEvent(eventId);

    return useMemo(() => {
        let result = speakers ?? [];

        if (filter) result = result.filter(filter);

        if (sortFunction) result = sortBy(result, sortFunction);
        // default sort [order,name]
        else if (sortFunction === undefined) result = sortBy(result, ['order', (s) => normalizeStringForSort(event.language, s.name)]);

        return result;
    }, [speakers, event, filter, sortFunction]);
}
